import script from "./Mint.vue?vue&type=script&setup=true&lang=js"
export * from "./Mint.vue?vue&type=script&setup=true&lang=js"

import "./Mint.vue?vue&type=style&index=0&id=4d508d9f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d508d9f"]])

export default __exports__